/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListMediaPartnersRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {ListMediaPartnersResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const listMediaPartners = (request: ListMediaPartnersRequest, options?: CashRequestOptions) => post<ListMediaPartnersRequest, ListMediaPartnersResponse>("/2.0/cash/list-media-partners", request, {...options, rejectOnError: true })